module.exports = __webpack_public_path__ + "static/media/4.7fa74845.png";